import { redirect } from "@tanstack/react-router";

/** Author profiles removed from the site: old URL → 301 to the QbD Group author page. */
const REMOVED_AUTHOR_SLUGS = new Set(["leen-de-taeye", "sandy-adjemian", "eline-neutjens"]);

export function redirectRemovedAuthor(slug: string, prefix: "/en" | "/es" | "/zh-cn") {
  if (REMOVED_AUTHOR_SLUGS.has(slug)) {
    throw redirect({ href: `${prefix}/author/qbd-group`, statusCode: 301 });
  }
}
